import FJUtil from '../../util/FJUtil';
import FJNetworkStore from '../../store/FJNetworkStore';
import FJMessageStore from '../../store/FJMessageStore';
import FJLocalStore from '../../store/FJLocalStore';
import FJActionModal from './FJActionModal';
import FJConstant from '../../constants/FJConstant';
import FJImageStore from '../../store/FJImageStore';
import {
    setSliceFreeNumCreationAction,
    setSliceCreationListAction,
    setSliceHistoryListAction,
    setSliceCreditNumberAction,
    setSliceSelectListAction,
    setSliceIsProjectLoadingAction,
    setSliceTaskStatusAction,
    setSliceProgressAction,
    setSliceCurrentQueueAction,
    setSliceQueueNumberAction,
    setSliceBatchDownloadLoadingAction,
    setSliceHistoryListLoadStatusAction,
    setSliceHeaderTabIndexAction,
    setSliceIsLogin,
    setSelectedDownloadList,
    setSliceIsShowMobileGiftBtu,
} from '../slices/FJSliceCommon';
import FJConfig from '../../config/FJConfig';
import { MAX_POLLING_ERROR_TIME, TASK_POLLING_INTERVAL } from '../../config/dataConfig/FJGenerateData';
import FJActionImageToImage from './FJActionImageToImage';
import FJActionImageManipulation from './FJActionImageManipulation';
import FJAppConstant from '../../constants/FJAppConstant';
import FJActionObjectErase from './FJActionObjectErase';
import FJActionPhotoBgRemover from './FJActionPhotoBgRemover';
import { setSliceAutoBackgroundRemoveFreeNum, setSliceBackgroundRemoveFreeNum } from '../slices/FJSlicePhotoBgRemover';
import FJActionFake3d from './FJActionFake3d';
import FJActionAIVideoGenerator from './FJActionAIVideoGenerator.js';
import FJActionImageEnhancer from './FJActionImageEnhancer';
import FJActionAIAudioGenerator from './FJActionAIAudioGenerator.js';
import FJActionVideoRemoveBg from './FJActionVideoRemoveBg.js';
import {
    setSliceVideoAutoBackgroundRemoveFreeNum,
    setSliceVideoBackgroundRemoveFreeNum,
} from '../slices/FJSliceVideoBgRemover.js';
import FJLimitedCouponStore from '../../store/FJLimitedCouponStore.js';
import FJTextBasedEditingConfig from '../../config/appConfig/FJTextBasedEditingConfig.js';
import { setHighLightFreeNum } from '../slices/FJTextBasedEditing.jsx';

let _eventIdList = [];

const _getPollingTime = appType => {
    if (appType === FJAppConstant.IMAGE_TO_IMAGE) {
        return 1000 * 10;
    }
    if (appType === FJAppConstant.AI_VIDEO_DUB) {
        return 1000 * 4;
    }

    return TASK_POLLING_INTERVAL;
};

const FJActionCommon = {
    multiDownloadAction: function (ids, source, callback) {
        return async (dispatch, getState) => {
            if (!ids.length) return;
            const tool = FJUtil.getToolName();
            FJUtil.eaLog('ai tool download click', { source, tool });
            const { historyList, appType } = getState().common;
            const isVideo =
                appType === FJAppConstant.AI_VIDEO_GENERATOR ||
                appType === FJAppConstant.VIDEO_REMOVE_BG ||
                appType === FJAppConstant.AI_VIDEO_DUB;
            const isAudioGenerator = appType === FJAppConstant.AI_AUDIO_GENERATOR;
            let downloadHistoryList = historyList.filter(item =>
                isAudioGenerator ? ids.includes(item.id) && item.status === 'completed' : ids.includes(item.id),
            );

            // 如果下载的是text to image，ultra 模型全部任务没有完成时已完成任务无法点击下载。因为历史记录没有更新 从编辑记录拿数据
            if (appType === FJAppConstant.TEXT_TO_IMAGE && downloadHistoryList.length === 0) {
                const creationList = getState().common.creationList;
                downloadHistoryList = creationList.filter(item => ids.includes(item.id));
            }

            const urls = downloadHistoryList.map(item =>
                isVideo ? item.videoUrl : isAudioGenerator ? item.audioUrl : item.imgUrl,
            );

            if (urls.length === 0) {
                FJMessageStore.addMessage(
                    isVideo
                        ? FJLocalStore._('unable-to-perform-this-operation-video')
                        : FJLocalStore._('unable-to-perform-this-operation'),
                    'error',
                );
                callback && callback(false);
                return;
            }
            const isBatch = source === 'multiple choose';
            const isMObile = FJUtil.isMobile();
            if (isBatch) {
                if (isMObile) {
                    dispatch(FJActionModal.showGlobalLoadingAction());
                } else {
                    dispatch(setSliceBatchDownloadLoadingAction(true));
                }
            }
            await FJUtil.multiDownloadByUrls(urls, callback, {
                isVideo: isVideo,
                isAudioGenerator: isAudioGenerator,
                downloadHistoryList,
                isWebm: appType === FJAppConstant.VIDEO_REMOVE_BG,
            });
            if (isBatch) {
                if (isMObile) {
                    dispatch(FJActionModal.hideGlobalLoadingAction());
                } else {
                    dispatch(setSliceBatchDownloadLoadingAction(false));
                }
            }
        };
    },

    multiDeleteAction: function (ids, callback) {
        return async (dispatch, getState) => {
            const { selectList } = getState().common;
            const isVideo =
                FJConfig.appType === FJAppConstant.AI_VIDEO_GENERATOR ||
                FJConfig.appType === FJAppConstant.VIDEO_REMOVE_BG ||
                FJConfig.appType === FJAppConstant.AI_VIDEO_DUB;
            const isAudioGenerator = FJUtil.isAudioGenerator();

            const _getDelTitle = () => {
                if (isVideo) {
                    return FJLocalStore._('delete-video');
                } else if (isAudioGenerator) {
                    return FJLocalStore._('delete-music');
                }
                return FJLocalStore._('delete-image');
            };

            const _getDelContent = () => {
                if (isVideo) {
                    return ids.length > 1
                        ? FJLocalStore._('videos-will-be-deleted').replace('xx', ids.length)
                        : FJLocalStore._('video-will-be-deleted').replace('xx', ids.length);
                } else if (isAudioGenerator) {
                    return FJLocalStore._('music-will-be-deleted').replace('xx', ids.length);
                } else {
                    return ids.length > 1
                        ? FJLocalStore._('xx-images-will-be-deleted-and-cannot-be-restored').replace('xx', ids.length)
                        : FJLocalStore._('xx-image-will-be-deleted-and-cannot-be-restored').replace('xx', ids.length);
                }
            };

            const title = _getDelTitle();
            const content = _getDelContent();

            const __delete = async () => {
                const __error = () => {
                    FJMessageStore.addMessage(FJLocalStore._('failed-to-delete-please-try-again'), 'error');
                    callback && callback(false);
                };
                try {
                    const result = await FJNetworkStore.deleteTaskList(ids);
                    const { code } = result;
                    if (code === 200) {
                        const newSelectList = selectList.filter(i => !ids.includes(i));
                        dispatch(setSliceSelectListAction(newSelectList));
                        if (isAudioGenerator) {
                            dispatch(FJActionAIAudioGenerator.setIsMultipleModeAction(newSelectList.length > 0));
                            dispatch(FJActionAIAudioGenerator.updateHistoryListAction({ callback }));
                        } else {
                            dispatch(FJActionCommon.updateHistoryListAction(callback));
                        }
                    } else if (code === 214) {
                        FJUtil.login();
                    } else {
                        __error();
                    }
                } catch (e) {
                    __error();
                }
            };
            dispatch(
                FJActionModal.showWarningModalAction({
                    title: title,
                    content: content,
                    footerDates: [
                        {
                            btnType: FJConstant.WARNING,
                            btnText: FJLocalStore._('delete'),
                            btnCallback: async () => {
                                __delete();
                            },
                        },
                        {
                            btnType: FJConstant.CANCEL,
                            btnText: FJLocalStore._('cancel'),
                            btnCallback: null,
                        },
                    ],
                }),
            );
        };
    },
    updateHistoryListAction: function (callback, options = {}) {
        return async (dispatch, getState) => {
            const { ignoreLoading = false } = options;
            if (getState().common.appType === FJAppConstant.AI_AUDIO_GENERATOR) {
                dispatch(FJActionAIAudioGenerator.updateHistoryListAction());
                return;
            }
            !ignoreLoading && dispatch(setSliceHistoryListLoadStatusAction(FJConstant.LOADING));
            try {
                const list = await FJNetworkStore.getTaskList(FJConfig.historyListType);
                if (list && list.length) {
                    const historyList = await FJUtil.parseList(list, { type: FJConstant.HISTORY });
                    const oldHistoryList = getState().common.historyList;
                    if (JSON.stringify(oldHistoryList) !== JSON.stringify(historyList)) {
                        dispatch(setSliceHistoryListAction(historyList));
                    }
                    callback && callback(historyList);
                } else {
                    dispatch(setSliceHistoryListAction([]));
                    callback && callback([]);
                }
                if (getState().common.appType === FJAppConstant.AI_VIDEO_GENERATOR) {
                    dispatch(FJActionAIVideoGenerator.checkIsShowGeneratingVideoNumAction());
                }
            } catch (error) {
                console.log(error);
            } finally {
                !ignoreLoading && dispatch(setSliceHistoryListLoadStatusAction(FJConstant.SUCCESS));
            }
        };
    },
    updateUseFreeLimitAction: function (callback) {
        return async (dispatch, getState) => {
            let freeNum = 0;

            let autoBackgroundRemoveFreeNum = 0;
            let backgroundRemoveFreeNum = 0;

            let videoBackgroundRemoveFreeNum = 0;
            let videoAutoBackgroundRemoveFreeNum = 0;
            try {
                const info = await FJNetworkStore.getUseFreeLimit();
                if (!info) return;
                const appType = getState().common.appType;
                if (appType === FJAppConstant.AI_VIDEO_GENERATOR) {
                    dispatch(FJActionAIVideoGenerator.updateUseFreeLimitAction(info));
                } else if (appType === FJAppConstant.AI_AUDIO_GENERATOR) {
                    dispatch(FJActionAIAudioGenerator.updateUseFreeLimitAction(info));
                }
                freeNum = info[FJConfig.freeLimitType];

                if (appType === FJAppConstant.PHOTO_REMOVE_BG) {
                    autoBackgroundRemoveFreeNum = info[FJConfig.autoFreeLimitType];
                    backgroundRemoveFreeNum = info[FJConfig.freeLimitType];

                    dispatch(setSliceAutoBackgroundRemoveFreeNum(autoBackgroundRemoveFreeNum));
                    dispatch(setSliceBackgroundRemoveFreeNum(backgroundRemoveFreeNum));
                } else if (appType === FJAppConstant.AI_TEXT_BASED_EDITING) {
                    dispatch(setHighLightFreeNum(info[FJTextBasedEditingConfig.freeLimitHighlightType]));
                } else if (appType === FJAppConstant.VIDEO_REMOVE_BG) {
                    videoBackgroundRemoveFreeNum = info[FJConfig.freeLimitType];
                    videoAutoBackgroundRemoveFreeNum = info[FJConfig.autoRemoverLimitType];

                    dispatch(setSliceVideoBackgroundRemoveFreeNum(videoBackgroundRemoveFreeNum));
                    dispatch(setSliceVideoAutoBackgroundRemoveFreeNum(videoAutoBackgroundRemoveFreeNum));
                }
            } catch (error) {
                // console.log(error);
            } finally {
                dispatch(setSliceFreeNumCreationAction(freeNum));
                callback && callback();
            }
        };
    },
    updateUserCreditsInfoAction: function (updateFreeLimit = false) {
        return (dispatch, getState) => {
            const { freeNumCreation, appType } = getState().common;
            const isVideoRemoveBg = appType === FJAppConstant.VIDEO_REMOVE_BG;
            const { autoBackgroundRemoveFreeNum, backgroundRemoveFreeNum } = getState().photoBgRemover;
            //有免费次数就更新，没有就不更新
            if (
                updateFreeLimit ||
                freeNumCreation > 0 ||
                (FJConfig.appType === FJAppConstant.PHOTO_REMOVE_BG &&
                    autoBackgroundRemoveFreeNum + backgroundRemoveFreeNum > 0)
            ) {
                dispatch(FJActionCommon.updateUseFreeLimitAction());
            }
            dispatch(FJActionCommon.updateCreditsInfo());
            getState().modals.upgradeModalData.display && dispatch(FJActionModal.hideUpgradeModalAction());
            isVideoRemoveBg && dispatch(FJActionVideoRemoveBg.updateGetCreditsAfterRemoveAllAction());
        };
    },
    initProjectInfoAction: function () {
        return async dispatch => {
            dispatch(setSliceIsProjectLoadingAction(true));
            let projectLoadingCount = 0;

            const __func = () => {
                dispatch(setSliceIsProjectLoadingAction(false));
                if (window.isEditPage && window.aiToolInitDone) window.aiToolInitDone();

                if (FJConfig.appType === FJAppConstant.IMAGE_TO_IMAGE) {
                    dispatch(FJActionImageToImage.loadImageToImagePageAction());
                    if (FJUtil.getIsNeedGenerateInImageToImage()) {
                        FJUtil.setIsNeedGenerateInImageToImage(false);
                        dispatch(FJActionImageToImage.generateAction());
                    }
                }
            };
            const __projectLoadingCallback = () => {
                projectLoadingCount++;
                if (projectLoadingCount === 2) {
                    __func();
                }
            };
            dispatch(setSliceCreationListAction([]));
            FJImageStore.initWatermarkCanvas();
            dispatch(setSliceIsLogin(FJUtil.isLogin()));

            if (FJUtil.isLogin()) {
                if (FJConfig.appType === FJAppConstant.AI_AUDIO_GENERATOR) {
                    dispatch(FJActionAIAudioGenerator.updateHistoryListAction());
                } else {
                    dispatch(FJActionCommon.updateHistoryListAction());
                }
                dispatch(FJActionCommon.updateCreditsInfo(__projectLoadingCallback));
                dispatch(FJActionCommon.updateUseFreeLimitAction(__projectLoadingCallback));
            } else {
                __func();
            }
        };
    },
    updateCreditsInfo: function (callback) {
        return async dispatch => {
            try {
                const data = await FJNetworkStore.getCreditsInfo();
                if (data) {
                    dispatch(setSliceCreditNumberAction(data.total));
                    if (window.isEditPage && window.EDIT_PAGE_API) {
                        window.EDIT_PAGE_API.updateCredit(data.total);
                    }
                }
            } catch (e) {
                // console.log(e);
            } finally {
                callback && callback();
            }
        };
    },

    pollingTaskAction(eventIdList, options) {
        // autoDefaultTaskStatus 成功后是否自动回到 default 状态
        const { callback, progressNumber = 1, autoDefaultTaskStatus = true, isUseFree = false } = options;
        let timer = null;
        let errorTime = 0;
        let quantityCompletion = 0;
        let preProgress = 0;
        let waitingEndTime = null;

        let finishTaskCount = 0;
        let failTaskCount = 0;
        let allTaskCount = eventIdList.length;
        const finishTaskCreationList = [];

        return async (dispatch, getState) => {
            const appType = getState().common.appType;
            const pollingTime = _getPollingTime(appType);

            //初始化状态
            dispatch(setSliceCurrentQueueAction(0));
            dispatch(setSliceQueueNumberAction(0));
            dispatch(setSliceProgressAction(0));
            const _clear = () => {
                clearTimeout(timer);
                timer = null;
            };
            const _request = async eventIdList => {
                try {
                    const result = await FJNetworkStore.getTaskState(eventIdList.join(','));
                    let isStopPolling = false;
                    let data = result;

                    if (!data) {
                        errorTime++;
                        if (errorTime >= MAX_POLLING_ERROR_TIME) {
                            callback({ waitingEndTime, type: FJConstant.ERROR });
                            isStopPolling = true;
                        } else {
                            timer = setTimeout(_request.bind(null, eventIdList), pollingTime);
                        }
                        return;
                    }

                    if (!Array.isArray(result)) {
                        // 处理数组类型的data
                        data = [result];
                    }

                    let allTaskStatus = '';
                    let errorMessage = '';
                    let queue = {};
                    let progress = 0;
                    const curEventIdList = [...eventIdList];
                    await Promise.all(
                        data.map(async item => {
                            if (item.soft_canceled) {
                                allTaskStatus = 'canceled';
                            } else {
                                switch (item.job_state) {
                                    case 'succeeded':
                                        if (item.out_put) {
                                            const list = item.out_put;
                                            const creationList = await FJUtil.parseList(list, {
                                                type: FJConstant.CREATIONS,
                                                isUploadWaterMark:
                                                    getState().common.appType !== FJAppConstant.FACE_SWAP,
                                            });
                                            finishTaskCreationList.push(...creationList);
                                        } else {
                                            failTaskCount++;
                                        }
                                        curEventIdList.splice(curEventIdList.indexOf(item.event_id), 1);
                                        finishTaskCount++;
                                        break;
                                    case 'waiting':
                                        (allTaskStatus === '' ||
                                            allTaskStatus === 'processing' ||
                                            allTaskStatus === 'canceled') &&
                                            (allTaskStatus = 'waiting');

                                        if (item.queue) {
                                            queue = item.queue;
                                        }
                                        break;
                                    case 'processing':
                                        allTaskStatus === '' && (allTaskStatus = 'processing');
                                        if (item.progress) {
                                            progress = item.progress;
                                        }
                                        break;
                                    case 'canceled':
                                        allTaskStatus = 'canceled';
                                        break;
                                    case 'failed':
                                        failTaskCount++;
                                        finishTaskCount++;
                                        errorMessage = item.error_msg;
                                        curEventIdList.splice(curEventIdList.indexOf(item.event_id), 1);
                                        if (failTaskCount === allTaskCount) {
                                            allTaskStatus = 'failed';
                                        }
                                        break;
                                    default:
                                        break;
                                }
                            }
                        }),
                    );

                    // 全部任务完成, 并且美元全部失败 则更改状态为成功
                    if (finishTaskCount >= allTaskCount) {
                        allTaskStatus !== 'failed' && (allTaskStatus = 'succeeded');
                    }
                    if (finishTaskCreationList.length > 0) {
                        const { creationList: curCreationList } = getState().common;
                        const finishTaskCreationListLength = finishTaskCreationList.length;
                        let newCreationList = [
                            ...finishTaskCreationList,
                            ...curCreationList.slice(finishTaskCreationListLength),
                        ];

                        dispatch(setSliceCreationListAction(newCreationList));
                    }

                    if (allTaskStatus) {
                        switch (allTaskStatus) {
                            case 'succeeded': {
                                dispatch(setSliceTaskStatusAction(FJConstant.SUCCESS));
                                dispatch(FJActionCommon.updateHistoryListAction());
                                const returnData = {
                                    waitingEndTime,
                                    type: FJConstant.SUCCESS,
                                    failTaskCount,
                                };
                                // 视频删除背景需要返回生成成果后的视频
                                callback(
                                    FJConfig.appType === FJAppConstant.VIDEO_REMOVE_BG ||
                                        FJConfig.appType === FJAppConstant.AI_VIDEO_DUB
                                        ? { ...returnData, finishTaskCreationList }
                                        : returnData,
                                );
                                autoDefaultTaskStatus &&
                                    setTimeout(() => {
                                        dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                                    }, 2000);
                                isStopPolling = true;
                                break;
                            }
                            case 'waiting':
                                dispatch(setSliceTaskStatusAction(FJConstant.WAITING));
                                break;
                            case 'processing':
                                dispatch(setSliceTaskStatusAction(FJConstant.GENERATING));
                                !waitingEndTime && (waitingEndTime = new Date().getTime());
                                break;
                            case 'canceled':
                                callback({ waitingEndTime, type: FJConstant.CANCEL });
                                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                                FJUtil.updateAllCreditInfo(isUseFree);

                                isStopPolling = true;
                                break;
                            case 'failed':
                                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                                callback({ waitingEndTime, type: FJConstant.ERROR, failTaskCount, errorMessage });
                                isStopPolling = true;
                                FJUtil.updateAllCreditInfo(isUseFree);

                                break;
                            default:
                                break;
                        }
                        //更新排队信息
                        if (queue) {
                            let currentQueue = queue?.current_queue || 0;
                            let queueNumber = queue?.queue_count || 0;
                            dispatch(setSliceCurrentQueueAction(currentQueue));
                            dispatch(setSliceQueueNumberAction(queueNumber));
                        }
                        //更新进度
                        if (progress) {
                            if (progress < preProgress) {
                                quantityCompletion++;
                            }
                            let sliceProgress = Math.round(
                                ((quantityCompletion + progress / 100) / progressNumber) * 100,
                            );
                            dispatch(setSliceProgressAction(sliceProgress));
                            preProgress = progress;
                        }
                        errorTime = 0;
                    }
                    if (isStopPolling) {
                        _clear();
                    } else {
                        timer = setTimeout(_request.bind(null, curEventIdList), pollingTime);
                    }
                } catch (error) {
                    console.log(error);
                    callback({ waitingEndTime, type: FJConstant.ERROR });
                    _clear();
                }
            };
            _eventIdList = [...eventIdList];
            timer = setTimeout(_request.bind(null, eventIdList), pollingTime);
        };
    },

    /**
     * 创建请求任务
     * @param {Function} request 请求函数
     * @param {Function} dispatch 派发函数
     * @returns {Promise<string>} 任务ID
     */
    createRequestTask: async function (request, dispatch) {
        const idInfo = await request();
        const { code, data: dataInfo } = idInfo;
        if (code === 401) {
            dispatch(FJActionModal.showUpgradeModalAction());
            return;
        } else if (code === 214) {
            FJUtil.login();
            return;
        }
        const eventId = dataInfo?.event_id;
        if (!eventId) {
            throw new Error('create task error');
        }
        return eventId;
    },

    /**
     * @desc 切换右侧界面
     * @param {number} index
     * @returns
     */
    setHeaderTabIndexAction: function (index) {
        return async (dispatch, getState) => {
            index === 0 && dispatch(setSliceSelectListAction([]));
            dispatch(setSliceHeaderTabIndexAction(index));

            if (index === 1 && getState().common.appType === FJAppConstant.AI_VIDEO_GENERATOR) {
                dispatch(FJActionAIVideoGenerator.setIsShowGeneratingVideoNumAction(false));
            }
        };
    },

    setSelectListAction: function (list) {
        return (dispatch, getState) => {
            const addMediaLibraryInfo = getState().modals.addMediaLibraryInfo;
            const { visible } = addMediaLibraryInfo;
            if (visible) return;
            dispatch(setSliceSelectListAction(list));
        };
    },

    /**
     * @desc 取消任务
     * @returns
     */
    cancelTaskAction: function (eventList = _eventIdList, autoDefaultData = true) {
        return async (dispatch, getState) => {
            const appType = getState().common.appType;

            switch (appType) {
                case FJAppConstant.IMAGE_TO_IMAGE:
                    dispatch(FJActionImageToImage.cancelTaskAction());
                    break;
                case FJAppConstant.IMAGE_ENHANCER:
                    // 移动端图片增强
                    dispatch(FJActionImageEnhancer.mobileCancelTaskAction());
                    break;
                default:
                    try {
                        eventList &&
                            eventList.length > 0 &&
                            (await Promise.all(
                                eventList.map(async eventId => {
                                    await FJNetworkStore.cancelTask(eventId);
                                }),
                            ));
                    } catch (e) {
                        FJMessageStore.addMessage(FJLocalStore._('cancel-to-delete-please-try-again'), 'error');
                    } finally {
                        autoDefaultData && dispatch(setSliceCreationListAction([]));
                        autoDefaultData && dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                    }
                    break;
            }
        };
    },

    /**
     * @desc 重新生成
     * @param {string} id
     * @returns
     */
    reGenerateAction: function (id) {
        return async (dispatch, getState) => {
            const appType = getState().common.appType;

            switch (appType) {
                case FJAppConstant.IMAGE_TO_IMAGE:
                    dispatch(FJActionImageToImage.reGenerateAction(id));
                    break;
                case FJAppConstant.PHOTO_RESTORATION:
                case FJAppConstant.PHOTO_COLORIZE:
                    dispatch(FJActionImageManipulation.reGenerateAction(id));
                    break;
                case FJAppConstant.OBJECT_ERASER:
                    dispatch(FJActionObjectErase.reGenerateAction(id));
                    break;
                default:
                    break;
            }
        };
    },

    /**
     * @desc ai 工具生成
     * @returns
     */
    generateAction: function () {
        return async (dispatch, getState) => {
            const appType = getState().common.appType;
            switch (appType) {
                case FJAppConstant.OBJECT_ERASER:
                    dispatch(FJActionObjectErase.generateAction());
                    break;
                case FJAppConstant.PHOTO_REMOVE_BG:
                    dispatch(FJActionPhotoBgRemover.generateAction());
                    break;
                default:
                    break;
            }
        };
    },

    /**
     * @desc 编辑历史
     * @param {Object} data
     * @param {Function} callback
     * @returns
     */
    editHistoryItemAction: function (data, callback, options = {}) {
        return (dispatch, getState) => {
            const appType = getState().common.appType;
            if (appType === FJAppConstant.FAKE_3D) {
                dispatch(FJActionFake3d.editFake3dHistoryAction(data, callback));
            }
            if (appType === FJAppConstant.PHOTO_REMOVE_BG) {
                dispatch(FJActionPhotoBgRemover.editPhotoBgRemoverHistoryAction(data, callback));
            }
            if (appType === FJAppConstant.VIDEO_REMOVE_BG) {
                dispatch(FJActionVideoRemoveBg.editVideoRemoveBgHistoryAction(data, callback, options));
            }
        };
    },
    /**
     * 检查用户空间是否切换
     * @param {*} spaceCheckType
     * @returns
     */
    userSpaceChangeAction: function (spaceCheckType) {
        return dispatch => {
            // 账号混淆的情况
            const abnormalState = [3, 4, 5];
            if (abnormalState.includes(spaceCheckType)) {
                dispatch(FJActionModal.accountChangesModalAction());
            }
        };
    },

    getCreditsAction: function () {
        return async dispatch => {
            if (!FJUtil.isMobile()) {
                const userSpaceType = await FJUtil.checkUserSpace();
                if (userSpaceType > 0) {
                    dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                    return;
                }
            }
            FJUtil.getCredits();
        };
    },

    setSelectedDownloadItemsAction: function (items) {
        return dispatch => {
            dispatch(setSelectedDownloadList(items));
        };
    },

    // 下载选中的素材
    downloadSelectedItemsAction: function () {
        return (dispatch, getState) => {
            const appType = getState().common.appType;
            FJUtil.eaLog('ai tool download click', { source: 'creation', tool: FJUtil.getToolName() });

            if (appType === FJAppConstant.PHOTO_REMOVE_BG) {
                dispatch(FJActionPhotoBgRemover.downloadSelectedItemsAction());
            } else {
                const selectedDownloadList = getState().common.selectedDownloadList;
                const { creationList } = getState().common;
                const { imageEnhancerCreationList } = getState().imageEnhancer;

                const list = appType === FJAppConstant.IMAGE_ENHANCER ? imageEnhancerCreationList : creationList;
                const isVideo = appType === FJAppConstant.AI_VIDEO_DUB;
                const options = {
                    isVideo,
                    errorMessage: isVideo
                        ? FJLocalStore._('unable-to-perform-this-operation-video')
                        : FJLocalStore._('unable-to-perform-this-operation'),
                };
                let downloadList;
                dispatch(setSliceBatchDownloadLoadingAction(true));

                if (list.length > 1) {
                    downloadList = list
                        .filter(item => selectedDownloadList.findIndex(sItem => sItem.id === item.id) !== -1)
                        .map(item => (isVideo ? item.videoUrl : item.imgUrl));
                } else if (list.length === 1) {
                    downloadList = [isVideo ? list[0].videoUrl : list[0].imgUrl];
                }
                FJUtil.multiDownloadByUrls(
                    downloadList,
                    () => {
                        dispatch(setSliceBatchDownloadLoadingAction(false));
                    },
                    options,
                );
            }
        };
    },

    /**
     * @desc 更新是否显示移动端礼包按钮
     */
    updateIsShowMobileGiftButton: function () {
        return dispatch => {
            const isMobile = FJUtil.isMobile();
            if (!isMobile) return;

            const isTeamSpace = isMobile ? false : FJUtil.isTeamSpace();
            const isTeamOwner = isMobile ? false : FJUtil.isTeamOwner();

            if (window.user_limited_time_coupon_info) {
                const isUsedCoupon = (!isTeamSpace || isTeamOwner) && FJLimitedCouponStore.isUsedCoupon();
                let tempData = window.user_limited_time_coupon_info;

                if (isUsedCoupon && tempData) {
                    const { expired_at } = tempData;
                    const nowTime = new Date().getTime();
                    const expireTime = expired_at * 1000;
                    const diffTime = expireTime - nowTime;

                    dispatch(setSliceIsShowMobileGiftBtu(true));
                    FJLimitedCouponStore.startCountdown(diffTime, true);
                    return;
                }
            }

            dispatch(setSliceIsShowMobileGiftBtu(false));
        };
    },
};
export default FJActionCommon;
